import { getAPIError, showErrorAlert, showSuccessAlert } from "utils/alert";
import { isHttpSuccess } from "utils/functions";

export const handleAPIResp = ({
    response,
    successMessage,
    defaultErrorMessage,
    backToEventPage,
}: {
    response: any;
    successMessage: string;
    defaultErrorMessage: string;
    backToEventPage: () => void;
}) => {
    if (isHttpSuccess(response.status)) {
        showSuccessAlert({
            message: successMessage,
        });
        backToEventPage();
    } else {
        showErrorAlert(getAPIError(response, defaultErrorMessage));
    }
};
